export const SMS_PLANS_RESET_STATE = 'SMS_PLANS_RESET_STATE';
export const SMS_PLANS_CURRENT_ITEM = 'SMS_PLANS_CURRENT_ITEM';

export const SMS_PLANS_REQUEST_LOADING = 'SMS_PLANS_REQUEST_LOADING';
export const SMS_PLANS_REQUEST_SUCCESS = 'SMS_PLANS_REQUEST_SUCCESS';
export const SMS_PLANS_REQUEST_FAILED = 'SMS_PLANS_REQUEST_FAILED';

export const SMS_PLANS_CURRENT_ACTION = 'SMS_PLANS_CURRENT_ACTION';
export const SMS_PLANS_RESET_ACTION = 'SMS_PLANS_RESET_ACTION';
